import {isEmpty} from "lodash"
import {getCycleValidationStatus} from "../helpers/getCycleValidationStatus"

export const injectValidationStatusHandler = (schedule) => {
  return !isEmpty(schedule) ? {...schedule, validationStatus: getCycleValidationStatus(schedule)} : {}
}
